import { withInstall } from "../utils/index.mjs";
import _Swipe from "./Swipe.mjs";
const Swipe = withInstall(_Swipe);
var stdin_default = Swipe;
import { swipeProps } from "./Swipe.mjs";
export {
  Swipe,
  stdin_default as default,
  swipeProps
};
